module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bb7c6671cf8cdffe1001dc509d20881c.svg";